// DrmPanelTestSection.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { format, fromUnixTime } from 'date-fns';
import DrmPanelSectionRow from '../container/DrmPanelSectionRow.js';
import { getDrmCapabilityTestcases } from '../resource/getDrmInfo.js';
import {
  Section,
  SectionBody,
  SectionTitle,
  Row,
  TestedAt,
  TestAsset,
} from '../style/SettingModal.js';

const testcaseObject = getDrmCapabilityTestcases().reduce(
  (accumulator, { keySystem, robustness }) => {
    if (!accumulator[keySystem]) {
      accumulator[keySystem] = [robustness];
    } else {
      accumulator[keySystem].push(robustness);
    }
    return accumulator;
  },
  {}
);

export const DrmPanelTestSection = ({ drmTestAtUnixTimestamp, messageId }) => {
  return (
    <StyledTestSection>
      {Object.keys(testcaseObject).map(keySystem => {
        return (
          <Section key={keySystem}>
            <SectionTitle>
              <div>{keySystem}</div>
              <TestedAt>
                {drmTestAtUnixTimestamp &&
                  format(
                    fromUnixTime(drmTestAtUnixTimestamp),
                    'yyyy/MM/dd HH:mm:ss'
                  )}
              </TestedAt>
            </SectionTitle>
            <SectionBody>
              {testcaseObject[keySystem].map(robustness => (
                <Row key={robustness}>
                  <DrmPanelSectionRow
                    robustness={robustness}
                    keySystem={keySystem}
                  />
                </Row>
              ))}
            </SectionBody>
          </Section>
        );
      })}
      {drmTestAtUnixTimestamp && (
        <Section
          css={`
            margin-top: 12px;
          `}
        >
          <TestAsset>{messageId ? `(${messageId})` : ''}</TestAsset>
        </Section>
      )}
    </StyledTestSection>
  );
};

DrmPanelTestSection.propTypes = {
  drmTestAtUnixTimestamp: PropTypes.number,
  messageId: PropTypes.string,
};

DrmPanelTestSection.defaultProps = {
  drmTestAtUnixTimestamp: null,
  messageId: null,
};

const StyledTestSection = styled.div``;

export default DrmPanelTestSection;
